import React from 'react'
import {Text} from 'ladder/ux/typography2'
import {ImoSummerSizzleBonusEarnings} from 'ladder/agents/dashboard/incentives2'
import {ReferralLink, TrackingLinkFaqs} from 'ladder/agents/dashboard/referral_link2'
import './share_page2.css'
import {QuotePageImpl} from 'ladder/agents/dashboard/quote2'

function SharePageMenuItem({thisSection, selectedSection, updateSection, label}) {
  const isSelected = selectedSection === thisSection
  const agentDashGray = '#636363' // TODO import from uxcolors
  return <div className={isSelected ? 'menu-item selected' : 'menu-item'}
              onClick={() => updateSection(thisSection)}>
    <Text weight='500'
          desktopSize='header-20'
          mobileSize='header-16'
          {...(!isSelected ? {color: agentDashGray} : {})}>
      {label}
    </Text>
  </div>
}

function SharePageMenu({sharePageCurrentSection, updateSharePageCurrentSection}) {
  return <div className='share-page-menu'>
    <SharePageMenuItem thisSection='quote'
                       selectedSection={sharePageCurrentSection}
                       updateSection={updateSharePageCurrentSection}
                       label='Get a price'/>
    <SharePageMenuItem thisSection='tracking-link'
                       selectedSection={sharePageCurrentSection}
                       updateSection={updateSharePageCurrentSection}
                       label='Refer with a link'/>
  </div>
}

export function SharePage2(props) {
  const {sharePageCurrentSection} = props
  return (<div className='share-page' id='ladder-agents-dashboard-share-page'>
        <SharePageMenu sharePageCurrentSection={props.sharePageCurrentSection}
                       updateSharePageCurrentSection={props.updateSharePageCurrentSection}/>
        <ImoSummerSizzleBonusEarnings
            summerSizzleBonusInfo={props.summerSizzleBonusInfo}
            summerSizzleTermsUrl={props.summerSizzleTermsUrl}/>
        {sharePageCurrentSection === 'quote' && <QuotePageImpl {...props}/> || <div className='tracking-link-section'>
          <ReferralLink
              userAgentLinks={props.userAgentLinks}
              windowMedia={props.windowMedia}
              sendBang={props.sendBang}/>
          <TrackingLinkFaqs agentWhatsATrackingLinkFaqToggle={props.agentWhatsATrackingLinkFaqToggle}
                            agentHowDoesItWorkFaqToggle={props.agentHowDoesItWorkFaqToggle}
                            sendBang={props.sendBang}/>
        </div>}
      </div>)
}
